<div class="gap-lg flex flex-col">
  <app-resume-etape [etape]="etape()" />
  @for (groupe of groupes(); track $index; let idx = $index) {
    <app-expansion-panel [titre]="'Groupe ' + (idx + 1)" [isOpen]="true">
      <app-chip
        class="ml-xxs"
        [label]="groupe.etat | convertEtatGroupeToString"
        [variant]="groupe.etat | getEtatGroupeVariant"
        ngProjectAs="chipRight"
      />
      <div class="px-lg pt-lg pb-xl gap-md grid">
        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Section nationale',
            value: groupe.sectionNationale ? 'Oui' : 'Non',
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Métier',
            value: groupe.idsReferentiels | convertIdsReferentielsToNoms,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Année',
            value: groupe.annee | i18nPlural: anneeMapping,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Nombre de recrutés maximum',
            value: groupe.recrutesMaximum,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Nombre de places minimum',
            value: groupe.placesMinimum,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Nombre de places maximum',
            value: groupe.placesMaximum,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{
            label: 'Publics cibles',
            value: groupe.publicsCibles,
          }"
        />

        <div class="gap-md flex">
          <app-chip
            [icon]="groupe.capp ? 'lucideCheck' : 'lucideX'"
            [variant]="groupe.capp ? 'positive' : 'negative'"
            label="CAPP"
          />
          <app-chip
            [icon]="groupe.ouvert ? 'lucideCheck' : 'lucideX'"
            [variant]="groupe.ouvert ? 'positive' : 'negative'"
            label="Ouvert"
          />
        </div>

        @if (groupe.etat !== etatGroupe.A_FAIRE) {
          <div class="gap-md grid grid-cols-2">
            <button (click)="modifierEtatGroupe(groupe, etatGroupe.REJETE)" hlmBtn type="button" variant="secondary">
              <ng-icon name="lucideCircleX" hlm size="sm" />
              Rejeter
            </button>
            <button (click)="modifierEtatGroupe(groupe, etatGroupe.VALIDE)" hlmBtn type="button" variant="secondary">
              <ng-icon name="lucideCircleCheck" hlm size="sm" />
              Valider
            </button>
          </div>
        }
      </div>
    </app-expansion-panel>
  }
</div>

<ng-template #item let-label="label" let-value="value">
  <div class="gap-md flex">
    <label class="text-content-secondary" hlmLabel>{{ label }}</label>
    <span>{{ value }}</span>
  </div>
</ng-template>
